import { faker } from '@faker-js/faker'

import { getPrice } from './Price'

import { UserServiceOfferOption } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getUserServiceOfferOption = asBuilder((): UserServiceOfferOption => {
  return {
    id: faker.string.uuid(),
    name: faker.string.uuid(),
    price: getPrice(),
    treatments: faker.helpers.multiple(() => ({
      id: faker.string.uuid(),
      name: faker.string.uuid(),
      times: {
        value: faker.number.int({ min: 1, max: 10 }),
        type: 'NUMBER_OF_TIMES',
      },
      material: { name: faker.string.uuid() },
      unitProperty: {
        id: faker.string.uuid(),
        name: faker.string.uuid(),
        value: faker.number.int(),
      },
      priceProperties: faker.helpers.multiple(() => ({
        id: faker.string.uuid(),
        name: faker.string.uuid(),
        values: Array.from({ length: faker.number.int({ min: 1, max: 5 }) }, () => ({
          name: faker.commerce.productName(),
          id: faker.string.uuid(),
        })),
      })),
    })),

    pointReward: {
      paybackPercentage: faker.number.int({ min: 10, max: 100 }),
      amount: faker.number.int(),
    },

    procedureProduct: {
      bundleId: faker.number.int(),
    },
  }
})
